export default __webpack_public_path__ + "static/media/love-kills.9bacf7d9.png";